import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeatRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsRepeatRightLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M17.0002 1.58594L21.4144 6.00015L17.0002 10.4144L15.5859 9.00015L17.5859 7.00015H5.00015V12.0002H3.00015V5.00015H17.5859L15.5859 3.00015L17.0002 1.58594ZM21.0002 12.0002V19.0002H6.41436L8.41436 21.0002L7.00015 22.4144L2.58594 18.0002L7.00015 13.5859L8.41436 15.0002L6.41436 17.0002H19.0002V12.0002H21.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsRepeatRightLeft;
